import { render, staticRenderFns } from "./Singleselect.vue?vue&type=template&id=64b996ff&scoped=true"
import script from "./Singleselect.vue?vue&type=script&lang=js"
export * from "./Singleselect.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Singleselect.vue?vue&type=style&index=1&id=64b996ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b996ff",
  null
  
)

export default component.exports